"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThumbsDown = void 0;
var react_1 = __importDefault(require("react"));
var ThumbsDown = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("path", { d: "M0 -2.38419e-07H2.90909V9.6H0V-2.38419e-07ZM16 8.8C16 9.68 15.3455 10.4 14.5455 10.4H9.95636L10.6473 14.056L10.6691 14.312C10.6691 14.64 10.5455 14.944 10.3491 15.16L9.57818 16L4.79273 10.728C4.52364 10.44 4.36364 10.04 4.36364 9.6V1.6C4.36364 0.72 5.01818 -2.38419e-07 5.81818 -2.38419e-07H12.3636C12.9673 -2.38419e-07 13.4836 0.399999 13.7018 0.975999L15.8982 6.616C15.9636 6.8 16 6.992 16 7.2V8.8Z", fill: "currentColor" }))); };
exports.ThumbsDown = ThumbsDown;
